const downloads = {
  title: "הורדות",
  gamOnline: "גלאור ברשת",
  reminderTitle: "הורד את GAM Command Center",
  reminderSubtitle: "גש מהר יותר מכל מכשיר",
  website: "אתר סלולרי",
  desktop: "תוכנה למחשב",
  android: "אנדרואיד",
  iphone: "אייפון",
  later: "אח״כ",
} as const;
export default downloads;
